export default "__VITE_ASSET__DDDoX66A__"